import { render, staticRenderFns } from "./RedFlagsSelect.vue?vue&type=template&id=44926e85&"
import script from "./RedFlagsSelect.vue?vue&type=script&lang=js&"
export * from "./RedFlagsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports